/**
 * Base class for all API errors
 */
export class APIError extends Error {
    url;
    status;
    content;
    /**
     * @param url - The URL where the error occurred.
     * @param status - The status code of the error.
     * @param content - The content of the error.
     */
    constructor(url, status, content) {
        super("Sherbert failed to fetch");
        this.url = url;
        this.status = status;
        this.content = content;
        this.name = "APIError";
    }
}
export class NetworkError extends Error {
    message;
    url;
    content;
    constructor(message, url, content) {
        super(message);
        this.message = message;
        this.url = url;
        this.content = content;
        this.name = "NetworkError";
    }
}
/**
 * Error class for handling aborted requests.
 */
export class AbortError extends Error {
    reason;
    /**
     * @param reason - The reason for the abort.
     */
    constructor(reason) {
        super("Request aborted");
        this.reason = reason;
        this.name = "AbortError";
    }
}
/**
 * Error class for handling bad request errors.
 */
export class BadRequestError extends Error {
    message;
    stack;
    url;
    detail;
    title;
    instance;
    /**
     * @param message - The error message.
     * @param stack - The stack trace of the error.
     * @param url - The URL where the error occurred.
     * @param detail - Detailed information about the error.
     * @param title - The title of the error.
     * @param instance - The instance of the error.
     */
    constructor(message, stack, url, detail, title, instance) {
        super(message);
        this.message = message;
        this.stack = stack;
        this.url = url;
        this.detail = detail;
        this.title = title;
        this.instance = instance;
        this.name = "BadRequestError";
    }
}
/**
 * Error class for handling unauthorized errors.
 */
export class UnauthorizedError extends Error {
    detail;
    title;
    instance;
    url;
    /**
     * @param detail - Detailed information about the error.
     * @param title - The title of the error.
     * @param instance - The instance of the error.
     * @param url - The URL where the error occurred.
     */
    constructor(detail, title, instance, url) {
        super("Unauthorized");
        this.detail = detail;
        this.title = title;
        this.instance = instance;
        this.url = url;
        this.name = "UnauthorizedError";
    }
}
